import { FlyerDetailPageEditType } from "../flyer-detail-page-state/flyer-detail-page-state.interface";

export function createFlyerDetailPageSubHeaderText(
  pageLabel: string,
  editType: FlyerDetailPageEditType
): string {
  const heading = `${pageLabel} - `;

  switch (editType) {
    case "position":
      return appendPositionEditHeaderText(heading);
    case "page":
      return appendPageEditHeaderText(heading);
    case "comments":
      return appendCommentsHeaderText(heading);
    case "assets":
      return appendAssetsEditHeaderText(heading);
    default:
      return heading;
  }
}

function appendPositionEditHeaderText(headerText: string): string {
  return `${headerText}Edit Position Details`;
}

function appendPageEditHeaderText(headerText: string): string {
  return `${headerText}Edit Page Details`;
}

function appendCommentsHeaderText(headerText: string): string {
  return `${headerText}Comments`;
}

function appendAssetsEditHeaderText(headerText: string): string {
  return `${headerText}Assets`;
}
